require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-79-hourly-estimation.json") })
        }
      }, "path---article-79-hourly-estimation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-79-hourly-estimation!./.cache/json/article-79-hourly-estimation.json
// module id = 567
// module chunks = 231608221292675